import React, { Component } from 'react';
import styled from 'styled-components';
import * as MDICONS from '@material-ui/icons';
import { connect } from 'react-redux'
import { updateCompany } from '../../../../store/actions/companyActions';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../../constants/routes';
import logo from '../../../../assets/logo/roundedLogo.png';
import Loader from 'react-loader-spinner';

const EditButton = styled.div` 
    .btn {
        color: #fafafa;
        border-color: #040926;
        background-color: #040926;
        margin: 2px;

        &:hover {
            background-color: #040850;
        }

        &:active {
            background-color: #040850;
        }
    }
`;


class EditCompanyForm extends Component {

    constructor(props) {
        super()

        this.state = {
            phone: "",
            address: "",
            selectedDp: null,
            selectedDpPreview: "",
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { companyData } = this.props;
        const { coid } = companyData;
        const { phone, address, selectedDp } = this.state;
        this.props.updateCompany(coid, selectedDp, phone, address);
    }

    handleFileSelect = (e) => {
        let reader = new FileReader();
        console.log(reader)
        let selectedDp = e.target.files[0];

        if (selectedDp && this.checkMimeType(e)) {
            reader.onloadend = () => {
                this.setState({
                    selectedDp,
                    selectedDpPreview: reader.result,
                });
            }
        }
        reader.readAsDataURL(selectedDp)
    }

    checkMimeType = (e) => {
        let files = e.target.files;
        let err = '';
        const types = ['image/jpeg', 'image/png', 'image/JPEG', 'image/PNG']
        for (var x = 0; x < files.length; x++) {
            if (!types.includes(files[x].type)) {
                err = 'File is not in a supported format\n';
            }
        };
        if (err !== '') {
            e.target.value = null // discard selected file
            console.log(err)
            return false;
        }
        return true;
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    componentDidMount() {
        const { companyData } = this.props;
        const { phone, address } = companyData;

        this.setState({
            phone,
            address
        });
    }

    render() {
        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: seeing the state of form (do styling adjustments but be cautious with state)
        ///
        const { isCompanyUpdating, isPictureAdded } = this.props.company;
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }
        const relevantSubmitComponent = isCompanyUpdating ?
            (<React.Fragment>
                <Loader
                    type="TailSpin"
                    color={this.props.themeColors.themeColor}
                    height={20}
                    width={20}
                />
                <br></br>
                <p style={textStyle}>{(isPictureAdded ? "Updating your company profile..." : "Updating your company profile...")}</p>
                <br></br>
            </React.Fragment>)
            :
            (<button className="btn btn-dark btn-sm" type="submit" >Update info</button>);

        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: return the form
        ///
        const formLabelStyle = {
            fontSize: "12px",
            fontWeight: "bold",
        };

        const zStyle = {
            left: "260px",
            right: "0px",
            top: "160px",
            position: "absolute",
            zIndex: "auto",
        };


        const { companyData, modalWidth } = this.props;
        const { profilePic } = companyData;
        const { phone, address } = this.state;

        const { selectedDpPreview, selectedDp } = this.state;
        var selectedDpComponent = <img src={selectedDpPreview ? selectedDpPreview : profilePic ? profilePic : logo} alt="" className="avatar" id="profilePic" style={{ width: "150px", height: "150px" }} />;

        return (
            <div className="dynamicModalContainer">
                <div className="dynamicModalSm">
                    {/* Moved out of form to prevent onSubmit handle */}
                    {/* SELECT DP */}
                    <div className="form-group text-center">
                        <label style={formLabelStyle}>Display picture</label>
                        <div className="align-items-center">
                            <div>
                                {selectedDpComponent}
                                <button className="btn btn-light btn-sm" style={zStyle} >
                                    <label htmlFor="files" style={{ fontWeight: "bold" }}>
                                        <MDICONS.EditRounded />
                                    </label>
                                </button>
                            </div>
                            <input type="file" className="file" id="files" style={{ fontWeight: "bold", fontSize: "8px", display: "none" }} onChange={this.handleFileSelect} />

                        </div>
                    </div>

                    {/* MAIN FORM */}
                    <form onSubmit={this.handleSubmit}>
                        <div className="form-group text-left">
                            <label htmlFor="inputText" style={formLabelStyle}>Phone</label>
                            <input type="tel" className="form-control" id="phone" placeholder="Hint: +441234567899" pattern="[+]{1}[0-9]{2,}" onChange={this.handleChange} required defaultValue={phone} />
                        </div>
                        <div className="form-group text-left">
                            <label htmlFor="inputText" style={formLabelStyle}>Work</label>
                            <input type="text" className="form-control" id="address" onChange={this.handleChange} required defaultValue={address} />
                        </div>
                        <br></br>
                        {relevantSubmitComponent}
                    </form>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    // console.log(state.firebase.data.Company)
    return {
        company: state.company,
        themeColors: state.theme,
        userData: state.firebase.profile,
        companyData: state.firestore.data.Company,
        project: state.project,
        userId: state.firebase.auth.uid,
        modalWidth: state.appControl.modalWidth,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateCompany: (coid, selectedDp, phone, address) => dispatch(updateCompany(coid, selectedDp, phone, address)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditCompanyForm);
